import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🤯", key: "dontKnowWhereToStart" },
  { emoji: "👁️", key: "cantVisualize" },
  { emoji: "💰", key: "budgetUncertainty" },
  { emoji: "⏰", key: "noTime" },
]

export default function HomeBlockerPage() {
  return <RadioCardListPage translationKey="homeBlocker" options={OPTIONS} />
}
